import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import App from "./pages/App/App";
import Beverages from "./pages/Beverages/Beverages";
import Dispensing from "./pages/Dispensing/Dispensing";
import Accessories from "./pages/Accessories/Accessories";
import Resources from "./pages/Resources/Resources";
import Contact from "./pages/ContactUs/ContactUs";
import Order from "./pages/OrderHere/OrderHere";
import FAQ from "./pages/FAQ/FAQ";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/beverages" element={<Beverages />} />
          <Route path="/dispensing" element={<Dispensing />} />
          <Route path="/accessories" element={<Accessories />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/order" element={<Order />} />
        </Routes>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
